import { createSlice } from '@reduxjs/toolkit';
import { updateRequirement } from './updateRequirementThunk';
import { QueryState } from 'common/enums';
import { IUpdateRequirementState, UpdateRequirementEmptyState } from './updateRequirementState';

const initialState: IUpdateRequirementState = UpdateRequirementEmptyState;

export const updateRequirementSlice = createSlice({
  name: 'updateRequirementResponses',
  initialState,
  reducers: {
    resetUpdateRequirementState: () => {
      return initialState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(updateRequirement.pending, (state) => {
        state.state = QueryState.AWAIT;
      })
      .addCase(updateRequirement.fulfilled, (state) => {
        state.state = QueryState.UPDATED;
      })
      .addCase(updateRequirement.rejected, (state) => {
        state.state = QueryState.FAIL;
      });
  }
});

export const { resetUpdateRequirementState } = updateRequirementSlice.actions;
export default updateRequirementSlice.reducer;
